import { OktaAuth } from '@okta/okta-auth-js'
import { OktaClientId } from './params'

const OKTA_DOMAIN = 'flytrex.okta.com' // TODO: Move to env variable
/* // cspell:disable-next-line */

export const OKTA_REDIRECT_URL = window.location.origin + '/login/callback'

export const oktaAuth = new OktaAuth({
  issuer: `https://${OKTA_DOMAIN}`,
  clientId: OktaClientId,
  redirectUri: OKTA_REDIRECT_URL,
  scopes: ['openid', 'profile', 'email', 'groups'],
  responseType: 'code',
  pkce: false,
})
